import { render, staticRenderFns } from "./FacilityRecords.vue?vue&type=template&id=79ca872a&"
import script from "./FacilityRecords.vue?vue&type=script&lang=js&"
export * from "./FacilityRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports